export default {
  'menu.servers': 'Gestion des serveurs',
  'menu.user.center': 'Compte',
  'menu.dashboard': 'Tableau de bord',
  'menu.devices': 'Appareils',
  'menu.addressBook': "Carnets d'adresses",
  'menu.addressBook.personal': 'Personnel',
  'menu.addressBook.shared': 'Partagé',
  'menu.users': 'Utilisateurs',
  'menu.audits': "Journaux d'audit",
  'menu.audits.conn': 'Connexion',
  'menu.audits.file': 'Transfert de fichiers',
  'menu.audits.alarm': 'Alarme',
  'menu.audits.console': 'Console',
  'menu.login': 'Connexion',
  'menu.roles': 'Rôles',
  'menu.strategies': 'Stratégies',
  'menu.groups': 'Groupes',
  'menu.groups.user': "Groupes d'utilisateurs",
  'menu.groups.device': "Groupes d'appareils",
  'menu.settings': 'Paramètres',
  'menu.settings.general': 'Paramètres généraux',
  'menu.settings.smtp': 'Configuration SMTP',
  'menu.settings.oidcProviders': 'Fournisseurs OIDC',
  'menu.settings.ldap': 'Configuration LDAP',
  'menu.customClients': 'Clients personnalisés',
  'menu.list.audit-list': "Liste d'audit",
  'menu.list.audit-list.File': 'Transfert de fichiers',
  'menu.list.audit-list.Connection': 'Connexion',
  'menu.list.audit-list.Alarm': 'Alarme',
};
